import { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import ApplicationSkeleton from '~/components/ApplicationSkeleton';

const AsyncCongregationList = lazy(
  () => import('~/containers/CongregationList')
);

export default [
  <Route path="/congregations" key="/congregations">
    <Suspense fallback={<ApplicationSkeleton />}>
      <AsyncCongregationList />
    </Suspense>
  </Route>,
];
